<template>
  <div class="footer" :class="{'mobile-footer': !!isMobile}">
    <div class="wrap">
      <div class="link-wrap" :class="[!isMobile ? 'ms-flex-start': '']">
        <div class="link-box ms-flex-start">
          <div class="service-box">
            <div class="title">全国统一服务热线</div>
            <div class="phone">400-138-1308</div>
            <!-- <div class="kefu-box ms-flex-middle">
              <img src="@/assets/icons/icon-wechart.png" alt="" class="icon">
              <div class="label">客服中心</div>
            </div> -->
          </div>
          <div class="link-item" v-for="(item, index) in linkList" :key="index">
            <div class="title">{{ item.name }}</div>
            <div class="link-subitem pointer" v-for="subItem in item.channelList" :key="subItem.id" @click="handleSubClick(subItem)">{{ subItem.name }}</div>
          </div>
        </div>
        <div class="qrcode-box ms-flex-middle-between">
          <div class="qrcode-item" v-for="item in imgList" :key="item.id">
            <div class="title">{{ item.name }}</div>
            <img :src="$imgPrefix + item.coverFilePath" alt="" class="img">
            <div class="tip">{{ item.alias }}</div>
          </div>
        </div>
      </div>
      <div class="rights-link ms-flex-middle-between">
        <div class="rights-box ms-flex-middle">
          <div>版权所有@2006-2024</div>
          <!-- <div class="ml-12">南宁市良庆区五象大道 665 号南宁环球金融中心 T2 栋 13 层 1307 号</div> -->
        </div>
        <div>地址：中国（广西）自由贸易试验区钦州港片区中马钦州产业园区中马北一街智慧产业园免税商城4楼425室</div>
        <div class="ms-flex-middle">
          <div>邮编：535008</div>
          <!-- <div class="ml-12">电话：0771-3213070</div> -->
          <!-- <div class="ml-12">传真：400-138-1308</div> -->
        </div>
      </div>
    </div>
    <div class="filings-box" :class="{'ms-flex-middle-center': !isMobile}">
      <a style="margin-right: 34px;" target="_blank" href="https://beian.miit.gov.cn/">桂ICP备2024038245号</a>
      <a rel="noreferrer" target="_blank" href="https://beian.mps.gov.cn/#/query/webSearch?code=45010802000801"><img src="@/assets/icons/icon-guohui.png" style="margin-right: 8px;" alt="">桂公网安备45010802000801</a>
      <a style="margin-left: 34px;" rel="noreferrer" target="_blank" :href="$imgPrefix + '/2024/09/04/营业执照.jpg'">营业执照</a>
      <a style="margin-left: 34px;" rel="noreferrer" target="_blank" :href="$imgPrefix + '/2024/09/04/危化品证.jpg'">危险化学品经营许可证：（桂N）自贸钦WHJY安许证字[2024]0187</a>
    </div>
  </div>
</template>

<script>
import { specialGroupList, menuList2 } from '@/api/index'
import { objArrayCompare, findParentsById } from '@/utils/index'
export default {
  name: 'MsFooter',
  data() {
    return {
      imgList: [],
      linkList: []
    }
  },
  methods: {
    getImages() {
      menuList2('1797448226791591938').then(res => {
        this.imgList = res.data.children || []
      })
    },
    getLinkList() {
      let linkList = [],
          ids = ['1797468712229507074', '1797470324746457090', '1797470411086204930', '1797470476009836545'];
      ids.map(async item => {
        let res = await specialGroupList(item)
        let index = ids.indexOf(item)
        linkList.push({
          index,
          ...res.data
        })
        console.log(linkList)
        linkList.sort((obj1, obj2) => {
          let val1 = obj1.index;
          let val2 = obj2.index;
          if (val1 < val2) {
            return -1;
          } else if (val1 > val2) {
            return 1;
          } else {
            return 0;
          }
        })
        this.linkList = linkList
      })
    },
    handleSubClick(row) {
      let parentRows = []
      findParentsById(this.$store.getters.menus, row.id, parentRows)
      let lastRow = parentRows[parentRows.length - 1]
      this.handleClick(lastRow)
      // this.handleClick(lastRow)
    }
  },
  created() {
    this.getImages()
    this.getLinkList()
  }
}
</script>

<style lang="scss" scoped>
.footer {
  background: var(--blue);
  .link-wrap {
    padding-top: 15px;
    padding-bottom: 5px;
    min-height: 225px;
  }
  .link-box {
    flex: 1;
    .service-box {
      box-sizing: border-box;
      padding-right: 35px;
      width: 245px;
      .phone {
        margin-top: 65px;
        height: 30px;
        font-weight: bold;
        font-size: 22px;
        color: #FFFFFF;
        line-height: 30px;
      }
      .kefu-box {
        margin-top: 56px;
        width: 106px;
        height: 27px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 13px;
        padding: 0 11px 0 14px;
        cursor: pointer;
        .icon {
          width: 17px;
          height: 17px;
          margin-right: 7px;
        }
        .label {
          height: 27px;
          font-size: 14px;
          color: #FFFFFF;
          line-height: 27px;
        }
      }
    }
    .title {
      height: 42px;
      font-weight: bold;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 42px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.25);
      position: relative;
      &::after {
        content: "";
        width: 70px;
        height: 1px;
        background: #fff;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
    .link-item {
      width: 130px;
      box-sizing: border-box;
      padding-right: 35px;
      .title {
        margin-bottom: 15px;
        &::after {
          width: 45px;
        }
      }
      .link-subitem {
        font-size: 14px;
        color: rgba(255, 255, 255, 0.8);
        line-height: 30px;
      }
    }
  }
  .qrcode-box {
    width: 370px;
    .qrcode-item {
      .title {
        height: 45px;
        font-weight: bold;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 45px;
        text-align: center;
        margin-bottom: 14px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.25);
        position: relative;
        &::after {
          content: "";
          width: 35px;
          height: 1px;
          background: #fff;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }
      .img {
        width: 110px;
        height: 110px;
        display: block;
        margin: 0 auto;
      }
      .tip {
        height: 36px;
        font-size: 14px;
        color: rgba(255, 255, 255, 0.8);
        line-height: 36px;
        text-align: center;
      }
    }
  }
  .rights-link {
    height: 58px;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    color: rgba(255, 255, 255, 0.8);
    font-size: 13px;
  }
  .filings-box {
    background: var(--dark-blue);
    height: 28px;
    font-size: 12px;
    line-height: 28px;
    a {
      color: rgba(255, 255, 255, 0.4);
      display: flex;
      align-items: center;
    }
  }
}
.mobile-footer {
  .link-wrap {
    padding-top: 15px;
    padding-bottom: 5px;
    min-height: 225px;
  }
  .link-box {
    position: relative;
    padding-top: 120px;
    .service-box {
      position: absolute;
      top: 15px;
      left: 50%;
      transform: translateX(-50%);
      box-sizing: border-box;
      width: 100%;
      padding-left: 5px;
      .phone {
        margin-top: 25px;
        height: 30px;
        font-weight: bold;
        font-size: 22px;
        color: #FFFFFF;
        line-height: 30px;
      }
      .kefu-box {
        margin-top: 25px;
        width: 106px;
        height: 27px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 13px;
        padding: 0 11px 0 14px;
        cursor: pointer;
        .icon {
          width: 17px;
          height: 17px;
          margin-right: 7px;
        }
        .label {
          height: 27px;
          font-size: 14px;
          color: #FFFFFF;
          line-height: 27px;
        }
      }
    }
    .title {
      height: 42px;
      font-weight: bold;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 42px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.25);
      position: relative;
      &::after {
        content: "";
        width: 70px;
        height: 1px;
        background: #fff;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
    .link-item {
      width: 25%;
      box-sizing: border-box;
      padding-right: 5px;
      padding-left: 5px;
    }
  }
  .qrcode-box {
    width: 100%;
    justify-content: space-around;
  }
  .rights-link {
    height: auto;
    min-height: 58px;
    flex-direction: column;
    padding: 5px 10%;
    box-sizing: border-box;
    & > div {
      text-align: center;
      padding: 5px 0;
    }
  }
  .filings-box {
    background: var(--dark-blue);
    height: auto;
    font-size: 12px;
    line-height: 28px;
    a {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 !important;
      color: rgba(255, 255, 255, 0.4);
      text-align: center;
    }
  }
}
</style>